import React from 'react';
import { InputText } from 'primereact/inputtext';

interface InputProps {
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  label: string;
  id: string;
  required?: boolean;
  disabled?: boolean;
  description?: string;
}

const Input: React.FC<InputProps> = ({ 
  type, 
  value, 
  onChange, 
  onBlur,
  label, 
  id, 
  required = false,
  disabled = false,
  description
}) => {
  return (
    <div className="form-group">
      <label htmlFor={id} className="form-label">
        {label} {required && <span style={{ color: 'red' }}>*</span>}
        {description && <span style={{ fontSize: '0.8em', color: '#666', fontWeight: 'normal', marginLeft: '5px' }}>({description})</span>}
      </label>
      <InputText
        type={type}
        id={id}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className="form-input"
        required={required}
        disabled={disabled}
      />
      {required && !value && (
        <small className="p-error">Este campo es obligatorio</small>
      )}
    </div>
  );
};

export default Input; 